import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, IconButton, InputAdornment, Grid, Tooltip } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import { FHEContainerForm, FHETextField, FHEButton, FHEWeatherAutoComplete, FormEditButton, FormSaveButton, FHEDivider } from 'data/components';
import { Toastr } from 'data/common';

class FormUser extends PureComponent {
    static propTypes = {
        sendDataFunc: PropTypes.func.isRequired,
        resetPassword: PropTypes.func,
        match: PropTypes.object.isRequired,
        user: PropTypes.object,
        history: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        searchCityUrl: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired
    };

    static defaultProps = {
        resetPassword: null,
        user: null
    };

    constructor(props) {
        super(props);
        const { type } = props;
        this.state = {
            passwordReseting: false,
            formDisabled: type === 'update',
            userForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false
        };
    }
    getDataForm = () => {
        const { type, user } = this.props;
        return {
            lastname: type === 'update' ? user.get('lastname') : null,
            firstname: type === 'update' ? user.get('firstname') : null,
            email: type === 'update' ? user.get('email') : null,
            emailFacebook: type === 'update' ? user.get('emailFacebook') : null,
            emailGoogle: type === 'update' ? user.get('emailGoogle') : null,
            address: type === 'update' ? user.get('address') : null,
            city: type === 'update' ? user.get('city') : null,
            postalCode: type === 'update' ? user.get('postalCode') : null,
            telFixe: type === 'update' ? user.get('telFixe') : null,
            telPort: type === 'update' ? user.get('telPort') : null,
            weatherCity: type === 'update' ? user.get('weatherCity') : null
        };
    };

    loadInputs = () => {
        this.setState({
            formDisabled: true,
            sendLoading: false,
            userForm: this.getDataForm()
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    formatForm = () => {
        const { userForm } = this.state;
        let form = userForm;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
        });
        this.setState({
            userForm: form
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    saveUser = () => {
        const { userForm } = this.state;
        const { sendDataFunc, history, profile } = this.props;

        this.formatForm();

        if (this.validateForm(userForm)) {
            this.setState({
                formDisabled: true,
                sendLoading: true
            });
            return sendDataFunc(userForm)
                .then(user => {
                    Toastr.success(Translator.translate('generic.user.actions.addUserSuccess', user.user.lastname, user.user.firstname));
                    if (profile.get('admin') || profile.getIn(['user_rights', 'myfhe'], []).includes('userDetails'))
                        return history.push({ pathname: `/myfhe/user/detail/${user.user._id}` });
                    return history.push('/myfhe/user');
                })
                .catch(error => {
                    Toastr.error(
                        Translator.translateWithFallback(`api.message.${error.message ? error.message : error}`, 'api.message.default'),
                        Translator.translate('generic.user.actions.addUserError', userForm.lastname, userForm.firstname)
                    );
                    this.setState({
                        formDisabled: false,
                        sendLoading: false
                    });
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate('generic.user.actions.addUserError', userForm.lastname, userForm.firstname)
                        );
                    }
                });
        }
    };

    confirmEdit = () => {
        const { userForm } = this.state;
        const { sendDataFunc, match } = this.props;

        this.formatForm();

        if (this.validateForm(userForm)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });
            return sendDataFunc(match.params.userId, userForm)
                .then(() => {
                    Toastr.success(Translator.translate('generic.user.actions.editUserSuccess', userForm.lastname, userForm.firstname));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        sendLoading: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(`api.message.${error.message ? error.message : error}`, 'api.message.default'),
                        Translator.translate('generic.user.actions.editUserError', userForm.lastname, userForm.firstname)
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate('generic.user.actions.editUserError', userForm.lastname, userForm.firstname)
                        );
                    }
                });
        }
    };

    deleteEmail = name => {
        const { userForm } = this.state;
        this.setState({
            userForm: { ...userForm, [name]: null }
        });
    };

    handleEdit = () => {
        const { formDisabled } = this.state;
        if (formDisabled === true) {
            this.setState({
                formDisabled: false
            });
        } else {
            this.loadInputs();
            this.setState({
                formDisabled: true,
                textInput_error: {}
            });
        }
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    handleChange = event => {
        const { userForm, textInput_error } = this.state;

        const fieldLengthRules = {
            telFixe: 20,
            telPort: 20,
            weatherCity: 100,
            address: 500,
            lastname: 255,
            firstname: 255,
            email: 255,
            emailGoogle: 255,
            emailFacebook: 255,
            postalCode: 50
        };

        let value = null;
        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let currentField = Object.keys(fieldLengthRules)[Object.keys(fieldLengthRules).indexOf(event.target.name)];
        let maxLength = Object.values(fieldLengthRules)[Object.keys(fieldLengthRules).indexOf(event.target.name)];

        if (event.target.value === '' || event.target.value === null) {
            value = null;
        } else {
            if (event.target.name === currentField) {
                if (event.target.value.length <= maxLength) {
                    value = event.target.value;
                } else {
                    value = userForm[currentField];
                }
            } else {
                value = event.target.value;
            }
        }

        this.setState({
            userForm: { ...userForm, [event.target.name]: value },
            textInput_error: newTextInput_error
        });
    };

    handleMeteo = meteoValue => {
        const { userForm } = this.state;
        this.setState({
            userForm: { ...userForm, ['weatherCity']: meteoValue }
        });
    };

    askResetPassword = e => {
        const { userForm } = this.state;
        e.preventDefault();
        Toastr.confirm(
            Translator.translate('generic.user.actions.confirmResetPassword', userForm.lastname, userForm.firstname),
            Translator.translate('generic.user.actions.resetPasswordTitle'),
            {
                onYes: this.resetPassword
            }
        );
    };

    resetPassword = () => {
        const { match, resetPassword } = this.props;
        const { userForm } = this.state;

        this.setState(
            {
                passwordReseting: true
            },
            () => {
                return resetPassword(match.params.userId)
                    .then(() => {
                        Toastr.success(Translator.translate('generic.user.actions.resetPasswordSuccess', userForm.lastname, userForm.firstname));
                    })
                    .catch(error => {
                        Toastr.error(
                            Translator.translateWithFallback(`api.message.${error.message ? error.message : error}`, 'api.message.default'),
                            Translator.translate('generic.user.actions.resetPasswordError', userForm.lastname, userForm.firstname)
                        );
                    })
                    .finally(() => {
                        this.setState({
                            passwordReseting: false
                        });
                    });
            }
        );
    };

    validateForm(form) {
        const errors = {};
        const regexTel = RegExp(/^(\+[1-9]{2}\s|0)([1-9])((\s|\.|-)?\d{2}){4}$/);

        if (this.isEmpty(form.firstname)) {
            errors['firstname'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.lastname)) {
            errors['lastname'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.email)) {
            errors['email'] = Translator.translate('general.fields.error.any.empty');
        } else if (!/^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(form.email)) {
            errors['email'] = Translator.translate('general.fields.error.string.regex.base');
        }
        if (this.isEmpty(form.telPort) && this.isEmpty(form.telFixe)) {
            errors['telPort'] = Translator.translate('general.fields.error.any.optional');
            errors['telFixe'] = Translator.translate('general.fields.error.any.optional');
        }
        if (!this.isEmpty(form.telPort) && !regexTel.test(form.telPort)) {
            errors['telPort'] = Translator.translate('general.fields.error.string.regex.base');
        }
        if (!this.isEmpty(form.telFixe) && !regexTel.test(form.telFixe)) {
            errors['telFixe'] = Translator.translate('general.fields.error.string.regex.base');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    }

    render() {
        const { textInput_error, formDisabled, userForm, sendLoading, passwordReseting } = this.state;
        const { type, profile, searchCityUrl } = this.props;

        const userRights = profile.getIn(['user_rights', 'myfhe'], []);
        const resetPasswordRights = profile.get('admin') || userRights.includes('userResetPassword');
        const updateUserRights = profile.get('admin') || userRights.includes('userDetailsUpdate');

        return (
            <Fragment>
                {type === 'add' ? (
                    <FormSaveButton sendFunc={this.saveUser} sendLoading={sendLoading} />
                ) : (
                    type === 'update' &&
                    updateUserRights && (
                        <FormEditButton
                            formDisabled={formDisabled}
                            handleEdit={this.handleEdit}
                            confirmEdit={this.confirmEdit}
                            sendLoading={sendLoading}
                        />
                    )
                )}

                <FHEContainerForm>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="lastname"
                                value={userForm.lastname === null ? '' : userForm.lastname}
                                error={textInput_error.lastname}
                                label={Translator.translate('general.table.column.lastname')}
                                name="lastname"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="firstname"
                                value={userForm.firstname === null ? '' : userForm.firstname}
                                error={textInput_error.firstname}
                                label={Translator.translate('general.table.column.firstname')}
                                name="firstname"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="email"
                                value={userForm.email === null ? '' : userForm.email}
                                error={textInput_error.email}
                                label={Translator.translate('general.table.column.email')}
                                name="email"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        {type === 'update' && (
                            <React.Fragment>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHETextField
                                        disabled
                                        id="emailFacebook"
                                        value={userForm.emailFacebook === null ? '' : userForm.emailFacebook}
                                        error={textInput_error.emailFacebook}
                                        label={Translator.translate('general.table.column.emailFacebook')}
                                        name="emailFacebook"
                                        InputProps={
                                            !formDisabled
                                                ? {
                                                      endAdornment: (
                                                          <span>
                                                              <InputAdornment position="end">
                                                                  <Tooltip title={Translator.translate('general.delete')} placement="bottom">
                                                                      <IconButton
                                                                          aria-label="Delete email address"
                                                                          onClick={this.deleteEmail.bind(this, 'emailFacebook')}
                                                                      >
                                                                          <DeleteIcon />
                                                                      </IconButton>
                                                                  </Tooltip>
                                                              </InputAdornment>
                                                          </span>
                                                      )
                                                  }
                                                : { disableUnderline: false }
                                        }
                                    />
                                </Grid>
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHETextField
                                        disabled
                                        id="emailGoogle"
                                        value={userForm.emailGoogle === null ? '' : userForm.emailGoogle}
                                        error={textInput_error.emailGoogle}
                                        label={Translator.translate('general.table.column.emailGoogle')}
                                        name="emailGoogle"
                                        InputProps={
                                            !formDisabled
                                                ? {
                                                      endAdornment: (
                                                          <InputAdornment position="end">
                                                              <Tooltip title={Translator.translate('general.delete')} placement="bottom">
                                                                  <IconButton
                                                                      aria-label="Delete email address"
                                                                      onClick={this.deleteEmail.bind(this, 'emailGoogle')}
                                                                  >
                                                                      <DeleteIcon />
                                                                  </IconButton>
                                                              </Tooltip>
                                                          </InputAdornment>
                                                      )
                                                  }
                                                : { disableUnderline: false }
                                        }
                                    />
                                </Grid>
                                {resetPasswordRights && (
                                    <Grid container item sm={12} md={6} lg={4} justify="center" alignItems="center">
                                        <FHEButton
                                            content={Translator.translate('generic.user.actions.resetPassword')}
                                            clickFunction={this.askResetPassword}
                                            loading={passwordReseting}
                                            disabled={passwordReseting}
                                        />
                                    </Grid>
                                )}
                            </React.Fragment>
                        )}
                    </Grid>
                </FHEContainerForm>

                <FHEDivider title={Translator.translate('general.details')} />
                <FHEContainerForm>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="address"
                                value={userForm.address === null ? '' : userForm.address}
                                error={textInput_error.address}
                                label={Translator.translate('general.table.column.address')}
                                name="address"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="city"
                                value={userForm.city === null ? '' : userForm.city}
                                error={textInput_error.city}
                                label={Translator.translate('general.table.column.city')}
                                name="city"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="postalCode"
                                value={userForm.postalCode === null ? '' : userForm.postalCode}
                                error={textInput_error.postalCode}
                                label={Translator.translate('general.table.column.postalCode')}
                                name="postalCode"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="telFixe"
                                value={userForm.telFixe === null ? '' : userForm.telFixe}
                                error={textInput_error.telFixe}
                                label={Translator.translate('general.table.column.telFixe')}
                                name="telFixe"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="telPort"
                                value={userForm.telPort === null ? '' : userForm.telPort}
                                error={textInput_error.telPort}
                                label={Translator.translate('general.table.column.telPort')}
                                name="telPort"
                                onChange={this.handleChange}
                            />
                        </Grid>

                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEWeatherAutoComplete
                                disabled={formDisabled}
                                id="weatherCity"
                                baseValue={type !== 'update' || userForm.weatherCity === null ? '' : userForm.weatherCity}
                                error={textInput_error.weatherCity}
                                label={Translator.translate('general.table.column.weatherCity')}
                                name="weatherCity"
                                query={searchCityUrl}
                                selectMeteo={this.handleMeteo}
                            />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user,
        searchCityUrl: state.data.searchCityUrl
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(FormUser)));



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/Form/FormUser.js